import MetaInfoItem from "./MetaInfoItem";

const DataDistribution = ({ data }) => (
  <div className="grid grid-cols-4 gap-2">
    {data.map(({ name, value }) => (
      <MetaInfoItem {...{ name, value }} key={name} />
    ))}
  </div>
);

export default DataDistribution;
